import { c as _c } from "react/compiler-runtime";
import { useShallow } from 'zustand/react/shallow';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { resolveWebviewEntry } from '@/utils/resolveWebviewEntry';

/**
 * api에 entry를 간편히 보내기 위한 훅\
 * TOSS 또는 KB_PAY에서 왔을 경우 다른 데이터를 보여주기 위한 목적으로 사용
 */
export const useWebviewTypeEntry = () => {
  const $ = _c(5);
  const [subDomain, webviewType] = useDeviceInfoStore(useShallow(_temp));
  let t0;
  if ($[0] !== subDomain || $[1] !== webviewType) {
    t0 = resolveWebviewEntry(subDomain, webviewType);
    $[0] = subDomain;
    $[1] = webviewType;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = {
      entry: t0
    };
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function _temp(state) {
  return [state.subDomain, state.webviewType] as const;
}